import { PUBLIC_DOMAIN } from '@constants';

export const PX_PER_SEC = 60;
export const MS_PER_TICK = 10;

export const ROTATE_MAX = 30;

export const ROTATE_START_ID = 'rotateStartPoint';
export const ROTATE_START_ICON = `${PUBLIC_DOMAIN}/imgs/start.c713cb29fc89d1048a169e27b61be33a.png`;

export const SUBTITME_MAX_MIN = 10;
